<script lang="ts">
	import { onMount } from 'svelte';
	import { getClient, query } from 'svelte-apollo';
	import AppContainer from '../../components/AppContainer.svelte';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import MixDataTable from '../../components/Segments/Mix/MixDataTable.svelte';
	import { getMixSegmentsQuery } from '../../graphql/queries/segments';

	const client = getClient();
	const getSegmentsOp = query(client, { query: getMixSegmentsQuery });

	function refresh() {
		getSegmentsOp.refetch();
	}

	onMount(() => {
		refresh();
	});
</script>

<AppContainer fluid>
	{#await $getSegmentsOp}
		<LoadingOverlay title="Loading..." spinner />
	{:then data}
		<MixDataTable data={data.data.getMixSegments} on:dispatchRefresh={refresh} />
	{:catch e}
		{e}
	{/await}
</AppContainer>
